module.exports = __webpack_public_path__ + "9d50f6c0ad60d5fbd6f14d171259176c.otf";